import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { fetchTourById } from "@/redux/slices/tourSlice";
import SecureCheckout from "../components/tour-booking/secure-checkout";
import ReviewOrderDetail from "../components/tour-booking/review-order-details";
import Coupon from "../components/tour-booking/coupon";
import PaymentDetails from "../components/tour-booking/payment-details";
import BookingSuccessModal from "../components/tour-booking/booking-success-modal";
import { toast } from "react-toastify";
const TourBookingPage = () => {
  const dispatch = useDispatch();

  const { userInfo } = useSelector((state) => state.user);

  const { paymentUrl, booking, payment, user, message, success } = useSelector(
    (state) => state.payment
  );

  const location = useLocation();
  const navigate = useNavigate();

  // Lấy dữ liệu tour từ Redux store

  const queryParams = new URLSearchParams(location.search);
  // Lấy dữ liệu từ location.state hoặc URL khi redirect
  const tourId = queryParams.get("tourId");
  const startDate = queryParams.get("startDate");
  const endDate = queryParams.get("endDate");
  const quantity = queryParams.get("quantity");

  const { selectedTour, loading, error } = useSelector((state) => state.tour);
  const [discount, setDiscount] = useState(null);
  useEffect(() => {
    if (tourId || !selectedTour.tourId) {
      dispatch(fetchTourById(tourId)); // Gọi API lấy chi tiết tour
    }
  }, [dispatch, tourId]);

  // Xử lý hiển thị Toast nếu có lỗi từ redirect
  useEffect(() => {
    if (queryParams.get("status") === "failed") {
      const message = queryParams.get("message");
      toast.error(`Lỗi: ${message}`);
    }
  }, [location.search, navigate]);

  return (
    <div className="content content-two">
      {!userInfo || !selectedTour ? (
        ""
      ) : (
        <>
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <SecureCheckout userInfo={userInfo} />
                <Coupon
                  tourId={tourId}
                  discount={discount}
                  setDiscount={setDiscount}
                />
                <PaymentDetails
                  userId={userInfo.id}
                  selectedTour={selectedTour}
                  startDate={startDate}
                  quantity={quantity}
                  paymentUrl={paymentUrl}
                  message={message}
                  success={success}
                  discount={discount}
                />
              </div>
              <div className="col-lg-4">
                <ReviewOrderDetail
                  selectedTour={selectedTour}
                  startDate={startDate}
                  endDate={endDate}
                  quantity={quantity}
                  discount={discount}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TourBookingPage;
